export const getApiBaseUrl = () => {
    return window.location.hostname === "localhost"
        ? "http://localhost:4000" // Local API URL
        : "https://ruby-red.onrender.com"; // Deployed API URL
};
